module.exports = __webpack_public_path__ + "img/multi_site.7fff27ab.svg";